import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPassword]'
})
export class PasswordDirective {

  public _shown = false;

  constructor(private el: ElementRef) {
    this.setup();
  }

  toggle(span: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      span.innerHTML = `<i class="fa fa-eye" style="font-size:15px;"></i>`;
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      span.innerHTML = `<i class="fa fa-eye-slash" style="font-size:15px;"></i>`;
    }
  }
  setup(){
    const parent = this.el.nativeElement.parentNode;
    const span = document.createElement('span');
    span.classList.add('input-group-text');
    span.innerHTML = `<i class="fa fa-eye-slash" style="font-size:15px;"></i>`;
    span.addEventListener('click', (event) => {
      this.toggle(span);
    });
    parent.appendChild(span);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directive/app-password/password.directive.ts